import { isValidJson, isValidJsObj } from 'utils/stringHelpers';

/**
 * Formats a JS object for use with the Ace Editor (in "json" mode)
 * @param {any} obj the expected js object
 * @returns {string} formatted json (with indenting)
 */
export const formatEditorValueFromJsObj = (obj: any) => {
  return obj && isValidJsObj(obj) ? JSON.stringify(obj, null, 2) : '{}';
};

/**
 * Formats a JSON string for use with the Ace Editor (in "json" mode)
 * note: The intent here is to use this formatter once on the value before it is passed to Ace, or
 *       perhaps subsequently on a triggered "clean-up". Issues arise (Ace's internal validation) if
 *       the editor's value is formatted on each change
 * @param {any} json the expected json string
 * @returns {string} formatted json (with indenting)
 */
export const formatEditorValueFromJson = (json: any) => {
  return !!json && isValidJson(json) ? formatEditorValueFromJsObj(JSON.parse(json)) : json;
};
